<template>
    <el-dialog
        title="用户协议"
        class="el-my-userAgreementDialog-dialog"
        center
        width="800px"
        top="4vh"
        :visible.sync="dialogVisible"
    >
        <article class="my-content">
            
                <h2 class="paragraph-title text-center">
                    医疗器械工业互联网企业节点用户协议
                </h2>
                <!-- <div
                    class="paragraph"
                >
                    欢迎阅读本用户协议！本政策适用于至数云服系统（网址：cloud.medatc.com，简称“本系统”）由上海至数企业发展有限公司（简称“至数云”）创建和运营。至数十分重视对用户隐私的保护，保护用户隐私是至数的一项基本政策。本系统主要面向企业用户。您注册和使用本系统之前，应当认真阅读、
                    充分理解《医疗器械工业互联网企业节点用户协议》（简称“本协议”）的全部内容。当您按照完善页面提示填写信息、阅读并同意本协议且完成注册程序后，即表示您已接受本协议的全部内容、成为本系统用户（
                    简称“用户”），本协议即构成用户与至数云（合称“双方”
                    ）之间有约束力的法律文件。您按照本协议约定同意并完善信息后，即可申请和使用医疗器械工业互联网企业节点提供的相关服务。
                </div> -->
                <h4 class="paragraph-title-2">总则</h4>
                <div
                    class="paragraph"
                >
                    1.1惠医软件云按照本协议的规定及不定期发布的操作规则向用户提供本协议项下的服务。
                </div>
                <div
                    class="paragraph"
                >
                    1.2
                    用户须同意:随着本协议的变动或扩展，本协议政策的内容可由惠医软件随时更新。更新后的隐私政策一旦在网页上公布即有效代替原来的隐私政策，并具有溯及力。
                </div>
                <div
                    class="paragraph"
                >
                    1.3
                    您在使用本系统提供的医疗器械工业互联网企业节点提供的相关服务之前，应仔细阅读本协议，如未经您明确同意，我们不会削减您依据本协议所应享有的权利。对于重大变更，我们将会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。
                </div>
                <h4 class="paragraph-title-2">协议术语</h4>
                <div
                    class="paragraph"
                >
                    本协议中所使用的以下术语，除非另有说明，否则具有以下含义：
                </div>
                <div
                    class="paragraph"
                >
                    医疗器械工业互联网平台：指本系统运营的基于工业互联网标识解析体系，为医疗器械行业提供数据采集、传输、分析、应用等一体化服务的平台。
                </div>
                <div
                    class="paragraph"
                >
                    医疗器械工业互联网标识解析服务：指本系统为您提供的基于工业互联网标识技术，对医疗器械产品、设备、流程、资源等进行唯一标识，并实现标识注册、分配、解析、查询等功能的服务。
                </div>
                <div
                    class="paragraph"
                >
                    标识：指由本系统按照国家工业互联网标识管理办法规定的编码规则和格式，为您在平台上接入的医疗器械产品、设备、流程、资源等分配的唯一编码。
                </div>
                <div
                    class="paragraph"
                >
                    标识载体：指用于存储或展示标识信息的物理或虚拟载体，如条码、二维码、射频电子标签（RFID）、生物识别等。
                </div>
                <div
                    class="paragraph"
                >
                    标识数据：指与标识相关联的医疗器械产品、设备、流程、资源等的属性信息、状态信息、位置信息等数据。
                </div>
                <div
                    class="paragraph"
                >
                    标识解析：指通过本系统将标识转换为相应的标识数据或者网络位置的过程，实现对医疗器械产品、设备、流程、资源等的信息获取和互联互通。
                </div>
                <h4 class="paragraph-title-2">协议内容</h4>
                <div class="paragraph-title-3"><strong>3.1 标识注册</strong></div>
                <div
                    class="paragraph"
                >
                    需要您填写真实、准确、完整的医疗器械产品、设备、流程、资源等的相关信息，申请注册标识。
                </div>
                <div
                    class="paragraph"
                >
                    本系统按照国家工业互联网标识管理办法规定的编码规则和格式，为您在平台上注册的医疗器械产品、设备、流程、资源等分配唯一标识，并将标识信息和标识数据同步至国家工业互联网标识解析体系。
                </div>
                <div
                    class="paragraph"
                >
                    当您的信息发生变更时应当及时更新自己在本系统上注册的医疗器械产品、设备、流程、资源等的相关信息，如有变更、作废或者注销等情况。
                </div>
                <div class="paragraph-title-3"><strong>3.2 标识解析</strong></div>
                <div
                    class="paragraph"
                >
                    您有权在平台上使用本系统提供的标识解析服务，通过输入或者扫描标识，查询医疗器械相关信息。
                </div>
                <div
                    class="paragraph"
                >
                    本系统应当遵守国家工业互联网标识解析体系的相关规范和要求，与国家顶级节点和二级节点保持连通，实现不同层级节点之间的标识数据同步和互联互通。
                </div>
                <div
                    class="paragraph"
                >
                    您应当合理使用平台上提供的标识解析服务，不得利用标识解析服务进行非法或者恶意的行为，如侵犯他人知识产权或者商业秘密，干扰或者破坏平台或者其他用户的正常运行等。
                </div>
                <div
                    class="paragraph"
                >
                    双方应当共同维护平台上提供的标识解析服务的公信力和权威性，不得故意制造或者传播虚假或者误导性的标识信息和标识数据。
                </div>
                <div class="paragraph-title-3"><strong>3.3 数据管理</strong></div>
                <div
                    class="paragraph"
                >
                    您有权在平台上使用我们提供的数据管理服务，对自己在平台上产生的标识数据进行查询、统计、展示等操作，并根据自己的需要选择是否与其他用户共享自己的标识数据。
                </div>
                <div
                    class="paragraph"
                >
                    我们不会与本公司以外的任何公司、组织和个人共享您的个人信息，除非以下情况：
                </div>
                <div
                    class="paragraph"
                >
                    3.3.1 获得您的明确授权同意；
                </div>
                <div
                    class="paragraph"
                >
                    3.3.2
                    根据适用的法律法规的规定、或按政府主管部门强制性要求的情况下进行提供；
                </div>
                <div
                    class="paragraph"
                >
                    3.3.3 为实现我们的产品或服务的核心功能所必要；
                </div>
                <div
                    class="paragraph"
                >
                    3.3.4
                    符合与您签署的相关协议（包括在线签署的电子协议以及相应的在线规则）或其他的法律文件约定所提供；
                </div>
                <div
                    class="paragraph"
                >
                    3.3.5
                    我们可能会将您的个人信息与我们的关联方（仅限于有控制权的关联方）共享。但我们只会共享必要的信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。
                </div>
                <div
                    class="paragraph"
                >
                    3.3.6
                    为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，确保操作环境安全与识别账号异常状态，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或惠医软件网站相关协议、规则的情况，我们可能使用您的会员信息、并整合有关网络日志以及我们关联公司、合作伙伴合法分享的信息，来判断您账户及交易风险、进行身份验证、安全事件的检测及防范，并依法采取必要的记录、审计、分析、处置措施。
                </div>
                <h4 class="paragraph-title-2">联系我们</h4>
                <div
                    class="paragraph"
                >
                    4.1 若您有任何疑问或需要，可通过线下联系我们。
                </div>
                <div
                    class="paragraph"
                >
                    4.2 一般情况下，我们将在收到消息后及时与您联系。
                </div>
          
        </article>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false"
                >已了解</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
export default {
    name: "userAgreementDialog",
    data() {
        return {
            dialogVisible: false
        };
    },
    components: {},
    computed: {},
    mounted() {},
    methods: {}
};
</script>

<style lang="scss">
.el-my-userAgreementDialog-dialog {
    .my-content {
        height: 600px;
        overflow-y:auto;
        margin: 10px;
        .paragraph-title {
            color: rgba(0, 0, 0, 0.85);
            font-weight: 600;
            font-size: 30px;
            line-height: 1.35;
        }
        .paragraph-title-2{
            margin-bottom: 0.5em;
            color: rgba(0, 0, 0, 0.85);
            font-weight: 600;
            font-size: 20px;
            line-height: 1.4;
        }
        .paragraph-title-3{
            font-size: 14px;
            line-height: 1.5;
            word-wrap: break-word;
            color: rgba(0, 0, 0, 0.65);
        }
        .text-center{
            text-align: center;
        }
        .paragraph{
            font-size: 14px;
            color: #666666;
            margin-bottom: 10px;
            text-indent: 2em;
        }
    }
    .el-dialog__header {
        border-bottom: 1px solid #cccccc;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/supplierCollaboration/userAgreementDialog.vue